/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect, useContext, createContext } from 'react';
import Base64 from 'base-64';
import { useBreakpoint } from '@rakutenfrance/breakpoint';
import { styled } from '@mui/material/styles';
export const LinkOrSpanContext = createContext({
    displayLink: false,
});
const StyledLink = styled('a', {
    shouldForwardProp: (prop) => prop !== 'hasUnderline',
})(({ hasUnderline }) => ({
    textDecoration: hasUnderline ? 'underline' : 'none',
}));
const StyledSpan = styled('span')(() => ({
    cursor: 'pointer',
}));
export const LinkOrSpan = ({ children, href, displayLink: displayLinkProps = undefined, className = '', action = '', onClick: additionalOnClick = undefined, dataQA, target, rel, hasUnderline = true, sx, }) => {
    var _a;
    // On regarde si le lien est à afficher, en priorité dans les props, sinon dans le context
    const context = useContext(LinkOrSpanContext);
    const displayLink = (_a = displayLinkProps !== null && displayLinkProps !== void 0 ? displayLinkProps : context === null || context === void 0 ? void 0 : context.displayLink) !== null && _a !== void 0 ? _a : true;
    const [displayLinkLocalState, setDisplayLinkLocalState] = useState(displayLink);
    const { md } = useBreakpoint();
    const handleOnClick = (event) => {
        var _a, _b;
        if (additionalOnClick)
            additionalOnClick(event);
        if (action === 'openDidomi') {
            (_b = (_a = window === null || window === void 0 ? void 0 : window.Didomi) === null || _a === void 0 ? void 0 : _a.preferences) === null || _b === void 0 ? void 0 : _b.show();
        }
    };
    const handleOnSpanClick = (event) => {
        var _a, _b;
        handleOnClick(event);
        if (event.ctrlKey || event.metaKey) {
            (_a = window === null || window === void 0 ? void 0 : window.open(href, '_self')) === null || _a === void 0 ? void 0 : _a.focus();
        }
        else if (target) {
            (_b = window === null || window === void 0 ? void 0 : window.open(href, target)) === null || _b === void 0 ? void 0 : _b.focus();
        }
        else {
            // override document.location.href to prevent redirection in cypress tests
            window.__location = window.__location || document.location;
            window.__location.href = href;
        }
    };
    useEffect(() => {
        if (!(md === null || md === void 0 ? void 0 : md.isBot)) {
            setDisplayLinkLocalState(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return displayLinkLocalState ? (React.createElement(StyledLink, { rel: rel, target: target, href: href, className: className, onClick: handleOnClick, "data-qa": dataQA, hasUnderline: hasUnderline, sx: sx }, children)) : (React.createElement(StyledSpan, { "data-ol": Base64.encode(href), className: className, onClick: handleOnSpanClick, "data-qa": dataQA, sx: sx }, children));
};
